/**
 * Stacking order for the issue-reporting surfaces.
 *
 * The flag panel is a screen-level overlay, so it sits far above the app. MUI's
 * tooltips default to `zIndex: 1500` (theme.zIndex.tooltip) and are PORTALLED to
 * `document.body`, which puts them in the same stacking context as the panel and
 * therefore BEHIND it.
 *
 * That is not hypothetical: the panel's own summary-line tooltip opens upward from
 * inside the panel, is taller than the gap above it, and had its lower rows hidden
 * under the panel — so the surface that exists to show the complete record was the
 * one surface truncating it.
 *
 * Declared together here, and derived rather than repeated, so the two can never
 * drift apart in a later edit to one file.
 */
export const ISSUE_PANEL_Z_INDEX = 9999;

/**
 * Above the panel — see above. Applied to the POPPER, not the tooltip div.
 *
 * Used by EVERY portalled layer that has to clear the panel, not just tooltips: the
 * item picker's Autocomplete popper (HITL-1623) defaults to `theme.zIndex.modal`
 * (1300) and so opened UNDERNEATH the panel, listing its options behind an opaque
 * surface. Same trap as the tooltip above, same fix.
 */
export const ISSUE_TOOLTIP_Z_INDEX = ISSUE_PANEL_Z_INDEX + 1;

/**
 * The lobby's backlog card had a layer here too, at 300, to clear the WS-error alert
 * at `zIndex: 200`. It is gone with the `position: fixed` it existed for: the card is
 * an in-flow item in `TaskRouterPage`'s column now, so there is nothing left for it to
 * stack against — see the card's own note on why floating it was the wrong trade.
 */
